import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ReactComponent as InadequacyIcon } from 'common-assets/assets/icons/target.svg';
import { zIndex } from '../theme/constants';
import { useIsMobile } from '../utils/useIsMobile';
import { Tooltip } from '../Tooltip/Tooltip';

import useStyles from './FundInadequacyIcon.style';

export interface FundInadequacyIconProps {
  variant?: 'small' | 'big' | 'small-circle',
  className?: string,
  classNameIcon?: string;
  forceDarkMode?: boolean;
  tooltipTitleClassName?: string;
  tooltipCustomZIndex?: number;
}

const FundInadequacyIcon: React.FC<FundInadequacyIconProps> = ({
  variant = 'small',
  className,
  classNameIcon,
  forceDarkMode,
  tooltipTitleClassName,
  tooltipCustomZIndex
}) => {
  const c = useStyles({ variant, forceDarkMode });
  const [t] = useTranslation('components');
  const isMobile = useIsMobile();
  const { tooltipAppBarZIndex } = zIndex;
  return (
    <Tooltip
      title={
        <div className={clsx(c.titleWrapper, tooltipTitleClassName)}>
          {isMobile && <div className={clsx(c.icon, classNameIcon)}>
            <InadequacyIcon />
          </div>}
          <span>{t('fund-inadequacy.warning')}</span>
        </div>
      }
      className={className}
      customZIndex={tooltipCustomZIndex ?? tooltipAppBarZIndex}
    >
      <div className={clsx(c.icon, classNameIcon)}>
        <InadequacyIcon />
      </div>
    </Tooltip>
  );
};

export { FundInadequacyIcon };
